export default {
    getDownloadFilesArr(state){
        return state.filesToBeDownloaded;
    },
    getFileWithID: (state) => (id) => {
        if(Object.hasOwnProperty.call(state.lastDownloadBatchID,id)){
             return state.lastDownloadBatchID[id];
        }
        return {};
     },
};